<template>
  <v-container fluid>
    <h1>Aggiornamenti</h1>
    <br>
    <h3>18 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Rimossa obbligatorietà del campo EAN in in fase di inserimento e modifica accessori.</p>
      </li>
      <li>
        <p>Aggiornato bytewood.it secondo le specifiche. Modificato testo sotto compravendi in attesa della sostituzione iframe.</p>
      </li>
    </ul>
    <br>
    <h3>14 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Aggiunta pagina Riparazioni Usato.</p>
      </li>
      <li>
        <p>Aggiunta tabella per visualizzare le riparazioni effettutate sull'usato Bytewood.</p>
      </li>
      <li>
        <p>Implementata funzionalità di associazione dell'usato Bytewood con accessori mancanti e pezzi di ricambio.</p>
      </li>
      <li>
        <p>NOTE: Avvenuta l'associazione, ricambi ed accessori vengono scaricati dal magazzino.</p>
      </li>
    </ul>
    <br>
    <h3>12 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Aggiunta tabella per visualizzare ricambi, servizi e lezioni nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di inserimento ricambi, servizi e lezioni nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di modifica ricambi, servizi e lezioni e sims nel magazzino.</p>
      </li>
      <li>
        <p>Aggiunto campo EAN agli smartphones.</p>
      </li>
      <li>
        <p>Spostato il campo descrizione da smartphones a smartphone_extra.</p>
      </li>
      <li>
        <p>Aggiunti box per il conteggio delle sim in base al gestore.</p>
      </li>
    </ul>
    <br>
    <h3>11 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Implementata funzionalità di inserimento accessori nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di modifica smartphones e sims nel magazzino.</p>
      </li>
      <li>
        <p>Tolto il reset automatico dai form di inserimento.</p>
      </li>
      <li>
        <p>Sostituito alert dei form di inserimento con una notifica meno invasiva.</p>
      </li>
      <li>
        <p>Risolto un bug che duplicava i cellulari nel DB (tabell smartphones) in fase di creazione a sistemati manualmente i duplicati.</p>
      </li>
    </ul>
    <br>
    <h3>8 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Aggiunta tabella per visualizzare le sim nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di inserimento sims nel magazzino.</p>
      </li>
      <li>
        <p>Cambiato nome del campo disco in HDD nella tabella degli smartphone nel magazzino.</p>
      </li>
      <li>
        <p>Aggiunta tabella per visualizzare gli accessori nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di modifica degli accessori nel magazzino.</p>
      </li>
    </ul>
    <br>
    <h3>7 Novembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Aggiunta tabella per visualizzare gli smartphone nel magazzino.</p>
      </li>
      <li>
        <p>Implementata funzionalità di inserimento smartphones nel magazzino.</p>
      </li>
      <li>
        <p>Aggiunto campo fornitore alla tabella degli smartphone nel magazzino.</p>
      </li>
    </ul>
    <br>
    <h3>29 Settembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Aggiunta possibilità di detrarre un anticipo dal calcolo di rateizzazione.</p>
      </li>
    </ul>
    <br>
    <h3>28 Settembre 2019</h3>
    <hr>
    <br>
    <ul>
      <li>
        <p>Spostati calcolatori nella sezione Strumenti di Contabilità.</p>
      </li>
      <li>
        <p>Accorpati i calcolatori in un unico form.</p>
      </li>
      <li>
        <p>Aggiunta funzionalità di calcolo Dilapay.</p>
      </li>
    </ul>
  </v-container>
</template>

<script>

  export default {
    name: 'Dashboard',
    components: {

    }
  }
</script>

<style>
</style>
